import React, { useEffect } from 'react';
import tocbot from 'tocbot';

const styles = {
  toc: {
    position: 'sticky' as const,
    top: '145px',
    height: 'calc(100vh - 150px)',
  },
};

import './TableOfContents.css?global';

export const TableOfContents = (): React.ReactElement => {
  useEffect(() => {
    tocbot.init({
      // Where to render the table of contents.
      tocSelector: `.toc`,
      // Where to grab the headings to build the table of contents.
      contentSelector: `.content-page`,
      // Which headings to grab inside of the contentSelector element.
      headingSelector: `h2,h3`,
      // How many heading levels should not be collapsed.
      // In our case, the toc is never collapsed
      collapseDepth: 6,

      hasInnerContainers: false,

      disableTocScrollSync: true,
    });

    return (): void => tocbot.destroy();
  }, []);

  return <div style={styles.toc} className={`toc`} />;
};
